import GameDetailPage from './GameDetailPage'

export default GameDetailPage